export enum QueryType {
  PROJECT_SHARE_TYPE = 'project-share-type',
  PROJECT_LICENSE = 'project-license',
  PROJECT_SHARE = 'project-share',
  PROJECT_PAYMENT_TYPE = 'project-payment-type',
  PROJECT_PAYMENT_PERIOD = 'project-payment-period',
  PROJECT_DEVELOPMENT_STEP = 'project-development-step',
  PROJECT_CHART = 'project-chart',
  PAYMENT_TAB = 'payment-tab',
  PAYMENT_ID = 'payment-id',
  PAYMENT_SHOW = 'payment-show',
  SELECT_PARENT = 'select-parent',
  REFERRAL_COUNT = 'referral-count',
  REFERRAL_LVL_1 = 'referral-lvl-1',
  REFERRAL_LVL_2 = 'referral-lvl-2',
  REFERRAL_LVL_3 = 'referral-lvl-3',
  REFERRAL_TAB = 'referral-tab',
  REFERRAL_SIDEBAR = 'referral-sidebar',
  REF = 'ref',
  REF_TYPE = 'ref-type',
  REF_STATE = 'ref-state',
}
